import React, { useEffect, useState } from 'react';
import cashIcon from '../../icons/cashIcon.svg';
import personalIcon from '../../icons/personalDetailIcon.svg';
import editIcon from '../../icons/Edit.svg';     
import InputBox from '../utilityComponents/InputBox';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { saveHostNotes } from '../../store/thunks/HostActions';

function Details({ details, loading, link }) {
  const dispatch = useDispatch();
  const params = useParams()
  const { hid } = params
  console.log(hid)
  /* ─────────────  earnings selectors ───────────── */
  const { loading: loadingHostEarnings, earnings: hostEarnings } =
    useSelector((state) => state.hostEarnings);
  const { loading: loadingDriverEarnings, earnings: driverEarnings } =
    useSelector((state) => state.driverEarnings);
  const { earnings: driverPendingEarnings } =
    useSelector((state) => state.driverPendingEarnings);
  const { earnings: hostPendingEarnings } =
    useSelector((state) => state.hostPendingEarnings);

  let earnings, pendingEarnings;
  switch (link) {
    case 'host':
      earnings = hostEarnings;
      pendingEarnings = hostPendingEarnings;
      loading = loadingHostEarnings;
      break;
    case 'driver':
      earnings = driverEarnings;
      pendingEarnings = driverPendingEarnings;
      loading = loadingDriverEarnings;
      break;
    default:
      earnings = {};
      pendingEarnings = {};
  }

  let total = 0,
    pendingTotal = 0;
  for (const earning in earnings) {
    total += earnings[earning].earnings.reduce((acc, a) => acc + a, 0);
  }
  for (const earning in pendingEarnings) {
    pendingTotal += pendingEarnings[earning].earnings.reduce((acc, a) => acc + a, 0);
  }

  /* ─────────────  host notes state ───────────── */
  const [notes, setNotes] = useState(details?.internalHostNotes || '');
  const [editing, setEditing] = useState(false);

  // keep local state in sync if the component gets new props
  useEffect(() => {
    setNotes(details?.internalHostNotes || '');
    setEditing(false);
  }, [details]);

  const handleSave = () => {
    if (!hid) return;
    dispatch(saveHostNotes({ hid, notes: notes.trim() }))
    setEditing(false);
  };

  return (
    <div className="flex w-full justify-between gap-5">
      {/* ───────────── Personal Details ───────────── */}
      <div className="w-[60%] flex flex-col">
        <div className="text-[24px] font-bold font-segoe flex gap-3 items-center">
          <img src={personalIcon} alt="personaldetail" />
          <p>Personal Details</p>
        </div>

        {loading ? (
          <div className="w-full py-5 h-30 rounded bg-[#f2f2f2] flex flex-col gap-8">
            <div className="w-full h-10 rounded bg-[#e0e0e0]"></div>
            <div className="w-full h-10 rounded bg-[#e0e0e0]"></div>
          </div>
        ) : (
          <>
            {/* personal fields */}
            <div className="flex flex-col gap-8 justify-between py-5">
              <div className="flex gap-5">
                <InputBox name="Name" value={`${details?.firstName} ${details?.lastName}`} />
                <InputBox name="Email" value={details?.email} icon />
              </div>
              <div className="flex gap-5">
                <InputBox name="Phone" value={details?.phoneNumber} icon />
                <InputBox
                  name="Address"
                  value={`${details?.address.line1} ${details?.address.line2 || ''}, ${details?.address.city}`}
                />
              </div>
            </div>

            {/* ───────────── Internal Host Notes ───────────── */}
            <div className="flex flex-col gap-2 pt-4">
              <div className="flex items-center gap-2">
                <p className="text-[20px] font-bold">Internal Host Notes</p>
                {!editing && (
                  <button
                    type="button"
                    onClick={() => setEditing(true)}
                    className="p-1 hover:opacity-80"
                  >
                    <img src={editIcon} alt="edit" className="w-4 h-4" />
                  </button>
                )}
                {editing && (
                  <button
                    type="button"
                    onClick={handleSave}
                    className="ml-2 px-3 py-1 text-sm font-semibold rounded bg-[#006aff] text-white hover:opacity-90"
                  >
                    Save
                  </button>
                )}
              </div>

              <textarea
                readOnly={!editing}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Write internal notes for this host..."
                className={`w-full min-h-[120px] border ${
                  editing ? 'border-[#006aff]' : 'border-[#d0d0d0]'
                } rounded-md p-3 focus:outline-none resize-y bg-white`}
              />
            </div>
          </>
        )}
      </div>

      {/* ───────────── Earnings ───────────── */}
      <div className="w-[32%] max-w-[500px] flex flex-col">
        <div className="text-[24px] font-bold font-segoe flex gap-3 items-center">
          <img src={cashIcon} alt="cash-icon" />
          <p>Earnings</p>
        </div>

        <div className="flex gap-2 h-full py-5">
          <div className="flex flex-col justify-center items-center gap-2 w-[50%] border border-[#dcdcdc] rounded-md p-1">
            {loading ? (
              <h2 className="text-base3 font-bold">$ ...</h2>
            ) : (
              <h2 className="text-base3 font-bold">${pendingTotal.toFixed(2)}</h2>
            )}
            <p className="text-base1 desktop:text-base2 text-light text-center">Active Bookings</p>
          </div>
          <div className="flex flex-col justify-center items-center gap-2 w-[50%] border border-[#dcdcdc] rounded-md">
            {loading ? (
              <h2 className="text-base3 font-bold">$ ...</h2>
            ) : (
              <h2 className="text-base3 font-bold">${total.toFixed(2)}</h2>
            )}
            <p className="text-base1 desktop:text-base2 text-light text-center">This Month Earning</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Details;
